import Icons from "../../assets/icon/index";
import { MdDelete } from "react-icons/md";
import HoverButton from "../hoverButton";
import { IoClose } from "react-icons/io5";
import Functions from "./index.function";
const JobsCom = (props) => {
  const { setconfirmdeletejob, user, confirmdeletejob } = Functions(props);
  return (
    <div
      className="xs:p-2 sm:p-3 lg:p-5 xs:rounded-2xl rounded-3xl cursor-pointer"
      style={{ backgroundColor: props.jobstheme }}
      onClick={props.onClick}
    >
      <div className="flex justify-between items-center">
        <div className="flex xs:gap-1 sm:gap-1 lg:gap-2">
          <img src={Icons.builingIcons} alt="" />
          <p className="text-primary font-onestMedium lg:text-lg">
            {props.subtitle}
          </p>
        </div>
        {!props.isApplied ? (
          <div className="flex xs:gap-1 sm:gap-1 lg:gap-2">
            {props.isdeletejob ? (
              <div
                className="group xs:w-8 cursor-pointer xs:h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 flex justify-center items-center rounded-full transform transition-transform duration-300 hover:scale-110 hover:shadow-lg"
                style={{ backgroundColor: props.btntheme }}
                onClick={() => setconfirmdeletejob(true)}
              >
                <MdDelete className="text-xl group-hover:text-red-700" />
              </div>
            ) : (
              ""
            )}
            <button
              className={`group xs:w-8 transform transition-transform duration-300 ${
                user?.role === "employer" || props.loadingapi
                  ? "opacity-70 cursor-not-allowed"
                  : "cursor-pointer hover:scale-110 hover:shadow-lg"
              }  xs:h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 flex justify-center items-center rounded-full `}
              style={{ backgroundColor: props.btntheme }}
              onClick={(e) => {
                e.stopPropagation();
                props.savedJob();
              }}
              disabled={user?.role === "employer" || props.loadingapi}
            >
              {props.loadingapi ? (
                <div className="flex justify-center items-center">
                  <div
                    className={`animate-spin rounded-full border-t-2 border-b-2  group-hover:border-primary border-secondary lg:w-6 lg:h-6 sm:w-4 sm:h-4 xs:w-3 xs:h-3`}
                  ></div>
                </div>
              ) : (
                <>
                  <img
                    src={props.isSaved ? Icons.Saved_JobIcon : Icons.saveIcons}
                    alt={props.isSaved ? "Saved Job Icon" : "Save Icon"}
                    className={`transition-colors duration-300 ${
                      user?.role === "employer" || props.loadingapi
                        ? "opacity-70 cursor-not-allowed"
                        : "group-hover:filter group-hover:brightness-0 group-hover:invert"
                    }  `}
                  />
                </>
              )}
            </button>
            <div
              className="group xs:w-8 cursor-pointer xs:h-8 sm:w-9 sm:h-9 lg:w-10 lg:h-10 flex transform -rotate-60 justify-center items-center rounded-full transition-transform duration-300 hover:scale-110 hover:shadow-lg"
              style={{ backgroundColor: props.btntheme }}
              onClick={props.navigate}
            >
              <img
                src={Icons.navigateIcons}
                alt="Navigate Icon"
                className="transition-colors duration-300 group-hover:filter group-hover:brightness-0 group-hover:invert"
              />
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
      <div>
        <h4 className="text-primary font-unboundedBold sm:pb-1 lg:py-1 lg:text-xl">
          {props.jobsTitle}
        </h4>
        <div className="xs:mb-2 xs:pt-1 sm:mb-2 lg:mb-2">
          <p
            className="text-primary font-onestLight line-clamp-2 lg:text-md leading-5 h-10"
            dangerouslySetInnerHTML={{ __html: props.jobsDis }}
          />
        </div>

        <div className="flex justify-start items-center xs:gap-1 sm:gap-1 lg:gap-3">
          <div className="bg-[#131313] text-secondary rounded-full lg:px-3 lg:py-1 sm:px-2 xs:px-2 xs:py-1">
            {props.timingbtnTitle}
          </div>
          {props?.hide_salary ? (
            ""
          ) : (
            <div className="bg-[#131313] text-secondary rounded-full lg:px-3 lg:py-1 sm:px-2 xs:px-2 xs:py-1">
              {props.salarybtnTitle}
            </div>
          )}
        </div>
        <div className="flex lg:gap-2 justify-start items-center xs:pt-[3px] sm:pt-2 lg:pt-2">
          <img src={Icons.locationIcons} alt="" />
          <p className="text-primary font-onestRegular lg:text-base">
            {props.location}
          </p>
        </div>
      </div>
      <div className="">
        {props.isApplied ? (
          <div
            className={`flex justify-center ${props.statusLayout} ${
              props.status ? "rounded-full py-1 sm:mt-2 lg:mt-2" : ""
            }`}
            style={{ backgroundColor: props.statusbg }}
          >
            <p className="text-secondary font-onestSemiBold xs:text-sm sm:text-sm lg:text-base xl:text-base 2xl:text-lg ">
              {props.status}
            </p>
          </div>
        ) : (
          ""
        )}
      </div>
      {confirmdeletejob && (
        <div className="fixed top-0 left-0 w-full h-screen bg-[#0d0d0def] flex justify-center items-center xs:p-5 sm:p-10 z-40">
          <div className="xs:w-[80%] sm:w-[45%] lg:w-[35%] 2xl:w-[26%] xl:w-1/3 bg-[#151515] xs:p-5 sm:p-8 rounded-3xl h-auto relative ">
            <div
              className="group flex justify-center items-center xs:w-5 xs:h-5 sm:w-7 sm:h-7 lg:w-8 lg:h-8 absolute -top-1 -right-1 rounded-full bg-goldMetallic cursor-pointer transform transition-transform duration-300 hover:scale-110"
              onClick={() => setconfirmdeletejob(false)}
            >
              <IoClose className="text-secondary group-hover:text-primary xs:text-lg sm:text-xl lg:text-2xl transform transition-transform duration-300 group-hover:rotate-180" />
            </div>
            <div className="flex justify-center items-center flex-col xs:pt-14 sm:pt-16 lg:pt-20 xl:pt-24">
              <div className="text-center lg:pb-7 xl:pb-14">
                <h2 className="text-secondary font-josefinSansMedium xs:pb-2 sm:pb-3 lg:pb-5 xs:text-xl sm:text-2xl lg:text-3xl xl:text-4xl">
                  Are you Sure
                </h2>
                <p className="text-secondary font-josefinSansLight xs:text-xs sm:text-xs lg:text-sm xl:text-base">
                  Delete the Job
                </p>
              </div>
              <div className="flex justify-center items-center my-10 lg:my-8">
                <HoverButton
                  onClick={props.deletejob}
                  extraClasses={
                    "group xs:w-44 xs:h-10 sm:w-48 sm:h-10 xl:w-64 lg:w-52 cursor-pointer bg-cover flex lg:h-12 items-center justify-center rounded-full transition-transform transform hover:scale-105 hover:shadow-md"
                  }
                  BtnTitle={
                    props.loadingToapi ? (
                      <div className="flex justify-center items-center">
                        <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                      </div>
                    ) : (
                      "Delete Job"
                    )
                  }
                  BtnTitleClasses={
                    "text-secondary font-onestMedium xs:text-sm sm:text-base lg:text-lg xl:text-xl transition-transform transform group-hover:scale-105 group-hover:text-primary"
                  }
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default JobsCom;
